import getAccessToken from './functions/getAccessToken';
import getCurrentUserId from './functions/getCurrentUserId';
import hasActiveSession from './functions/hasActiveSession';

const cognitoCoreStrategy = {
  getAccessToken,
  getCurrentUserId,
  hasActiveSession,
};

export { cognitoCoreStrategy };
